import React from 'react';
import { HelpCircle, AlertCircle } from 'lucide-react';

interface FormFieldProps {
  label?: string;
  children: React.ReactNode;
  required?: boolean;
  optional?: boolean;
  highlight?: boolean;
  tooltip?: string;
  error?: string;
  defaultValue?: string;
}

export default function FormField({
  label,
  children,
  required,
  optional,
  highlight,
  tooltip,
  error,
  defaultValue,
}: FormFieldProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <label className="block text-sm font-medium text-neutral-light">
            {label}
          </label>
          {tooltip && (
            <div className="group relative">
              <HelpCircle className="w-4 h-4 text-text-muted" />
              <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-3 py-2 bg-brand-surface text-xs text-neutral-light rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap">
                {tooltip}
              </div>
            </div>
          )}
        </div>
        {optional && <span className="text-xs text-text-muted">Optional</span>}
        {required && !optional && (
          <span className="text-xs text-accent">Required</span>
        )}
      </div>
      {children}
      {defaultValue && (
        <p className="text-xs text-text-muted">Default: {defaultValue}</p>
      )}
      {error && (
        <div className="flex items-center gap-2 mt-1.5">
          <AlertCircle className="w-4 h-4 text-rose-400" />
          <span className="text-xs text-rose-400">{error}</span>
        </div>
      )}
    </div>
  );
}
